module.exports = __webpack_public_path__ + "img/gallery-post-2.8154984f.jpg";